module.exports = require('crypto').createHash



//////////////////
// WEBPACK FOOTER
// ./~/create-hash/index.js
// module id = 45
// module chunks = 0 1 2 3